import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import manager from "../views/Manager.vue";
import app1 from "../App.vue";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    meta:{name:'登录'},
    component: Login
  },
  {
    path: '/manager',
    name: 'Manager',
    component: manager,
    redirect: '/manager/home',//重定向到主页
    children:[
      {path:'/403',name:'Auth',meta:{name:'无权限'},component:()=>import('../views/manager/Auth.vue')},
      {path:'home',name:'Home',meta:{name:'系统首页'},component:()=>import('../views/manager/Home.vue')},
      {path:'user',name:'User',meta:{name:'人员信息'},component:()=>import('../views/manager/User.vue')},
      {path:'Person',name:'Person',meta:{name:'个人信息'},component:()=>import('../views/manager/Person.vue')},
      {path:'password',name:'Password',meta:{name:'修改密码'},component:()=>import('../views/manager/Password.vue')},
      {path:'product',name:'product',meta:{name:'商品信息'},component:()=>import('../views/manager/product.vue')},
      {path:'productType',name:'productType',meta:{name:'商品分类'},component:()=>import('../views/manager/productType.vue')},
      {path:'shopping',name:'shopping',meta:{name:'商品展示'},component:()=>import('../views/manager/shopping.vue')},
      {path:'credit',name:'credit',meta:{name:'赊账人员管理'},component:()=>import('../views/manager/credit.vue')},
      {path:'notice',name:'notice',meta:{name:'系统公告'},component:()=>import('../views/manager/notice.vue')},
      {path:'orders',name:'Orders',meta:{name:'订单管理'},component:()=>import('../views/manager/Orders.vue')},
    ]
  },

 
  { path:'/register',name:'Register',meta:{name:'注册'},component:() => import('../views/Register.vue')},
  { path:'*',name:'404',meta:{name:'无法访问'},component:() => import('../views/404.vue')},
]

const router = new VueRouter({
  mode:'history',
  base:process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const appInstance  = new Vue(app1);
  appInstance.openFullScreen2();
  //to是到达的路由信息
  //from是开源的路由信息
  //next是帮助跳转路由的函数
  let adminPaths=['/manager/user']
  let user=(JSON.parse(localStorage.getItem('honey-user') || '{}'));
  if(to.path=='/'){
    next();
  }
  if(to.path=='/register'){
    next();
  }
  if(user.data.role!=='管理员'&& adminPaths.includes(to.path)){  
    //如果当前登录的用户不是管理员，然后当前的到达的路径是管理员才有权限访问的路径，那这个时候就让用户去到达一个没有权限的页面，不让他访问实际的页面
    next('/403')
  }else{
    next()
  }
  
  
})

export default router
